/**
 * MaizeFarmersTab — Registered women farmers list with Edit/Delete actions.
 */
import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { MapPin, Phone, Pencil, Trash2 } from 'lucide-react';
import { formatNumber } from '../../lib/utils';

const MaizeFarmersTab = ({ farmers = [], canEdit = false, onEdit, onDelete }) => (
  <Card>
    <CardContent className="p-0">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Farmer Name</TableHead>
            <TableHead>Village</TableHead>
            <TableHead>Phone</TableHead>
            <TableHead>Farm Size</TableHead>
            <TableHead className="text-right">Total Supplied</TableHead>
            <TableHead>Status</TableHead>
            {canEdit && <TableHead className="text-right">Actions</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {farmers.length === 0 ? (
            <TableRow>
              <TableCell colSpan={canEdit ? 7 : 6} className="text-center py-8 text-muted-foreground">
                No farmers registered yet
              </TableCell>
            </TableRow>
          ) : (
            farmers.map((farmer) => (
              <TableRow key={farmer.id} className="table-row-hover">
                <TableCell className="font-medium">{farmer.name}</TableCell>
                <TableCell>
                  <span className="flex items-center gap-1">
                    <MapPin className="h-3 w-3 text-muted-foreground" />
                    {farmer.village}
                  </span>
                </TableCell>
                <TableCell>
                  <span className="flex items-center gap-1">
                    <Phone className="h-3 w-3 text-muted-foreground" />
                    {farmer.phone}
                  </span>
                </TableCell>
                <TableCell>{farmer.farm_size_acres ? `${farmer.farm_size_acres} acres` : '-'}</TableCell>
                <TableCell className="text-right font-medium">{formatNumber(farmer.total_supplied || 0)} kg</TableCell>
                <TableCell>
                  <Badge className={farmer.is_active ? 'badge-success' : 'badge-warning'}>
                    {farmer.is_active ? 'Active' : 'Inactive'}
                  </Badge>
                </TableCell>
                {canEdit && (
                  <TableCell className="text-right">
                    <div className="flex items-center justify-end gap-1.5">
                      <Button size="sm" variant="outline" onClick={() => onEdit?.(farmer)} data-testid={`edit-farmer-${farmer.id}`} className="h-8 px-2.5">
                        <Pencil className="h-3.5 w-3.5 mr-1" />Edit
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => onDelete?.(farmer)} data-testid={`delete-farmer-${farmer.id}`} className="h-8 px-2.5 border-destructive/40 text-destructive hover:bg-destructive/10 hover:text-destructive">
                        <Trash2 className="h-3.5 w-3.5 mr-1" />Delete
                      </Button>
                    </div>
                  </TableCell>
                )}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);

export default MaizeFarmersTab;
